import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import OperationLogDrawer from '@/components/common/OperationLogDrawer';

const OperationLogDrawerHostContext = createContext(null);

/**
 * 在宿主全屏 Drawer 外层挂载，使操作记录 Drawer 不嵌套在宿主 Drawer 子树内，避免 rc-drawer push 导致宿主上移。
 */
export function OperationLogDrawerHostProvider({ children }) {
    const [payload, setPayload] = useState(null);

    const close = useCallback(() => setPayload(null), []);

    const open = useCallback(params => {
        setPayload({ ...params, open: true });
    }, []);

    const value = useMemo(() => ({ open, close }), [open, close]);

    return (
        <OperationLogDrawerHostContext.Provider value={value}>
            {children}
            {payload?.open ? <OperationLogDrawer open onClose={close} entityType={payload.entityType} entityId={payload.entityId} module={payload.module} maskClosable={payload.maskClosable ?? true} /> : null}
        </OperationLogDrawerHostContext.Provider>
    );
}

OperationLogDrawerHostProvider.propTypes = {
    children: PropTypes.node,
};

export function useOperationLogDrawerHost() {
    return useContext(OperationLogDrawerHostContext);
}
